import { Grid, Typography } from '@mui/material';
import { Img } from '@/components/blocks/MaterialImage';
import { Linkable } from '@/components/blocks/Linkable';
import { formatHref } from '@/utils/formatHref';

interface DpBreadcrumbCardProps {
	image: string;
	title: string;
	description: string;
	href?: string;
}

export const DpBreadcrumbCard: React.FC<DpBreadcrumbCardProps> = ({
	image,
	title,
	description,
	href,
}) => {
	const _href = href ? formatHref(href) : undefined;

	return (
		<Linkable
			type="button-base"
			href={_href}
			sx={{
				display: 'flex',
				flexDirection: 'column',
				'&:hover': {
					boxShadow: '0 0 5px 0px #9E9E9E',
					transition: 'box-shadow 0.3s ease',
				},
			}}
		>
			<Grid
				sx={{
					width: '210px',
					height: '127px',
					backgroundColor: 'Highlight',
				}}
			>
				<Img src={image} />
			</Grid>
			<Grid
				sx={{
					width: '210px',
					height: '89px',
					backgroundColor: '#F1F1F1',
					p: '8px 12px',
				}}
			>
				<Typography
					component={'h2'}
					sx={{
						color: '#2F2F2F',
						fontSize: 'var(--font-size-default)',
						fontWeight: 'bold',
						textAlign: 'left',
					}}
				>
					{title}
				</Typography>
				<Typography
					sx={{
						color: '#2F2F2F',
						fontSize: 'var(--font-size-caption)',
						fontWeight: 'normal',
						textAlign: 'left',
					}}
				>
					{description}
				</Typography>
			</Grid>
		</Linkable>
	);
};
